import { render, staticRenderFns } from "./side-nav-inner-toolbar.vue?vue&type=template&id=f9bf64b2&"
import script from "./side-nav-inner-toolbar.vue?vue&type=script&lang=js&"
export * from "./side-nav-inner-toolbar.vue?vue&type=script&lang=js&"
import style0 from "./side-nav-inner-toolbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports